import React from 'react';
import { styled } from '@linaria/react';

function TornEdge() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 176"
    >
      <path
        fill="hsl(210deg 15% 20%)"
        d="M13.1716 13.1716L0 0H16V176L2.82843 162.828C1.26633 161.266 1.26633 158.734 2.82842 157.172L13.1716 146.828C14.7337 145.266 14.7337 142.734 13.1716 141.172L2.82843 130.828C1.26633 129.266 1.26633 126.734 2.82842 125.172L13.1716 114.828C14.7337 113.266 14.7337 110.734 13.1716 109.172L2.82843 98.8284C1.26633 97.2663 1.26633 94.7337 2.82842 93.1716L13.1716 82.8284C14.7337 81.2663 14.7337 78.7337 13.1716 77.1716L2.82843 66.8284C1.26633 65.2663 1.26633 62.7337 2.82842 61.1716L13.1716 50.8284C14.7337 49.2663 14.7337 46.7337 13.1716 45.1716L2.82843 34.8284C1.26633 33.2663 1.26633 30.7337 2.82842 29.1716L13.1716 18.8284C14.7337 17.2663 14.7337 14.7337 13.1716 13.1716Z"
      ></path>
    </Svg>
  );
}

const Svg = styled.svg`
  position: absolute;
  width: 8px;
  height: calc(100% + var(--border-width) * 2);
  top: calc(var(--border-width) * -1);
  right: 0;
  bottom: calc(var(--border-width) * -1);
`;

export default TornEdge;
